import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const LinkedinIcon = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height={{ base: '7px', hashup: '10px' }}
			viewBox="0 0 16 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.8786 4.45166C12.0593 4.45166 13.1915 4.92067 14.0264 5.75551C14.8612 6.59035 15.3302 7.72263 15.3302 8.90327V14.0968H12.3625V8.90327C12.3625 8.50973 12.2061 8.1323 11.9279 7.85402C11.6496 7.57574 11.2722 7.4194 10.8786 7.4194C10.4851 7.4194 10.1076 7.57574 9.82936 7.85402C9.55108 8.1323 9.39474 8.50973 9.39474 8.90327V14.0968H6.427V8.90327C6.427 7.72263 6.89601 6.59035 7.73085 5.75551C8.56569 4.92067 9.69797 4.45166 10.8786 4.45166Z"
				fill={color}
			/>
			<path
				d="M3.4592 5.19336H0.491455V14.0966H3.4592V5.19336Z"
				fill={color}
			/>
			<path
				d="M1.97508 2.96774C2.7946 2.96774 3.45895 2.30339 3.45895 1.48387C3.45895 0.664352 2.7946 0 1.97508 0C1.15556 0 0.491211 0.664352 0.491211 1.48387C0.491211 2.30339 1.15556 2.96774 1.97508 2.96774Z"
				fill={color}
			/>
		</Icon>
	);
};
